module.exports = __webpack_public_path__ + "static/dessin-5c8b4696002e7717e713249bd8406807.png";